import React from 'react';

// components
import TableFilters from 'components/ag-table/TableFilters';
import { TableFilterConfig, TableFilterType } from 'components/ag-table/types';
import { SearchableSelectType } from 'components/inputs/searchableSelect';

// hooks
import useHandleQueryParams from 'hooks/helper/useHandleQueryParams';

// models
import { AuditTrailTimeframeOptions } from 'models/activty-log.model';

type AuditTrailFiltersProps = {
    personFilterOptions: { label: string; value: number }[];
};

const AuditTrailFilters: React.FC<
    React.PropsWithChildren<AuditTrailFiltersProps>
> = ({ personFilterOptions }) => {
    const [, setQueryParams] = useHandleQueryParams();

    const filtersConfig: TableFilterConfig[] = [
        {
            field: 'timeframe',
            placeholder: 'Timeframe',
            type: TableFilterType.DROPDOWN,
            meta: {
                options: [
                    {
                        label: 'Lifetime',
                        value: AuditTrailTimeframeOptions.LIFETIME,
                    },
                    {
                        label: 'This month',
                        value: AuditTrailTimeframeOptions.MONTH,
                    },
                    {
                        label: 'This week',
                        value: AuditTrailTimeframeOptions.WEEK,
                    },
                ],
            },
        },
        {
            field: 'person',
            label: 'By Person',
            placeholder: 'By Person',
            type: TableFilterType.DROPDOWN,
            meta: {
                options: [
                    { label: 'All', value: 'all' },
                    ...personFilterOptions,
                ],
            },
        },
    ];

    const handleFilterChange = (
        item: TableFilterConfig,
        value: string | number | SearchableSelectType[],
    ) => {
        setQueryParams({
            [item.field]: value as string,
        });
    };

    return (
        <TableFilters
            filtersConfig={filtersConfig}
            handleFilterChange={handleFilterChange}
            allowSearching={false}
            disableFilterChip={true}
        />
    );
};

export default AuditTrailFilters;
